function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1669",
  "data-name": "Group 1669",
  transform: "translate(-52 -96)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_558",
  "data-name": "Rectangle 558",
  width: 4,
  height: 4,
  rx: 1,
  transform: "translate(52 96)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_559",
  "data-name": "Rectangle 559",
  width: 4,
  height: 4,
  rx: 1,
  transform: "translate(57 96)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_560",
  "data-name": "Rectangle 560",
  width: 4,
  height: 4,
  rx: 1,
  transform: "translate(57 101)",
  fill: "#25a4b4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_561",
  "data-name": "Rectangle 561",
  width: 4,
  height: 4,
  rx: 1,
  transform: "translate(52 101)",
  fill: "#25a4b4"
}));

var SvgExpandedMenu = function SvgExpandedMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpandedMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expanded-menu.3c217008.svg";
export { ForwardRef as ReactComponent };